import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'view-pending-schedule-items-modal',
  templateUrl: './view-pending-schedule-items-modal.component.html',
})
export class ViewPendingScheduleItemsModal implements OnInit {
  @Input() pendingItems: any[];
  @Input() cancelledItems: any[];
  @Input() rejectedItems: any[];
  @Input() isRejected: boolean;
  public allItems: any[];
  public title = 'Pending Items';

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.setupPage();
  }

  private setupPage() {
    if (this.isRejected) {
      this.title = 'Rejected Items';

      this.allItems = [...this.rejectedItems].sort((a, b) => {
        return a.startTime.localeCompare(b.startTime);
      });
     } else {
       this.allItems = [...this.cancelledItems, ...this.pendingItems].sort((a, b) => {
         return a.startTime.localeCompare(b.startTime);
       });
     }
  }

  public open(item) {
    this.activeModal.close(item);
  }

  public closeModal() {
    this.activeModal.dismiss();
  }
}
